import React from 'react';
import {
  BrowserRouter as Router, Route, Routes as Switch,
} from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LandingPage from './containers/LandingPage';
import PrivateRoute from './components/PrivateRoute';
import PrivateRoute2 from './components/PrivateRoute2';
import Navbar from './components/navigation/Navbar';
import Home from './containers/Home';
import SignUp from './containers/users/SignUp';
import LogIn from './containers/users/LogIn';
import UserQuotations from './containers/UserQuotations';
import ClientQuotations from './containers/ClientQuotations';

const App = ({ setUser }) => {
  if (localStorage.getItem('token')) {
    setUser(true);
  }

  return (
    <Router>
      <Switch>
        <Route
          exact
          path="*"
          to="/metior"
          element={
            (
              <PrivateRoute2>
                <Navbar />
                <Home />
              </PrivateRoute2>
            )
          }
        />
        <Route
          exact
          path="/metior/user-quotations"
          element={
            (
              <PrivateRoute>
                <Navbar />
                <UserQuotations />
              </PrivateRoute>
            )
          }
        />
        <Route
          exact
          path="/metior/clients-quotations"
          element={
            (
              <PrivateRoute>
                <Navbar />
                <ClientQuotations />
              </PrivateRoute>
            )
          }
        />
        <Route exact path="/" element={<LandingPage />} />
        <Route exact path="/metior/signup" element={<SignUp />} />
        <Route exact path="/metior/login" element={<LogIn />} />
      </Switch>
    </Router>
  );
};

App.propTypes = {
  setUser: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setUser: (values) => dispatch({
    type: 'SET_USER',
    payload: values,
  }),
});

export default connect(null, mapDispatchToProps)(App);
